import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import AppShell from "@/components/AppShell";

/**
 * Convenience redirect: "My Kennel" in the side nav lands here. We
 * look up the calling user's kennel via `/breeders/mine`:
 *   - if one exists → forward to `/breeders/{id}` (BreederDetail page)
 *   - otherwise → forward to `/breeders?create=1` so the Add-Breeder
 *     dialog auto-opens (handled inside Breeders.jsx).
 *
 * Keeping this as a tiny resolver page (instead of a redirect helper)
 * gives us a stable URL for the nav bar that never 404s while the
 * lookup is in flight.
 */
export default function MyKennelRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/breeders/mine")
      .then((r) => {
        const id = r.data?.id;
        if (id) navigate(`/breeders/${id}`, { replace: true });
        else navigate("/breeders?create=1", { replace: true });
      })
      .catch(() => navigate("/breeders?create=1", { replace: true }));
  }, [navigate]);

  return (
    <AppShell>
      <div className="text-[#6B6B6B]" data-testid="my-kennel-loading">
        Loading your kennel…
      </div>
    </AppShell>
  );
}
